module.exports = __webpack_public_path__ + "static/img/4.d8bb604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/4.png
// module id = aZ27
// module chunks = 0